enum UIState {
  DESTROY = "destroy",
  NONE = "none",
  HOLD = "hold",
  DISBANDED = "disbanded",
  DISLODGED = "dislodged",
  BUILD = "build",
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export default UIState;
